import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, Lock } from "lucide-react";
import { useEffect } from "react";
import { useCourseStore } from "@/store/useStore";

/* ---------------- MOCK COURSES ---------------- */

const MOCK_COURSES = [
  { id: 1, title: "Calm Your Mind", description: "Simple techniques to regain calm.", image: "/courses/course-1.jpg", progress: 35, module_count: 4, lesson_count: 16 },
  { id: 2, title: "Anxiety Reset", description: "Reduce daily anxiety step by step.", image: "/courses/course-2.jpg", progress: 0, module_count: 6, lesson_count: 22 },
  { id: 3, title: "Panic Attack Toolkit", description: "Immediate panic relief tools.", image: "/courses/course-3.jpg", progress: 60, module_count: 5, lesson_count: 18 },
  { id: 4, title: "Sleep & Relaxation", description: "Improve sleep quality.", image: "/courses/course-4.jpg", progress: 0, module_count: 4, lesson_count: 14 },
  { id: 5, title: "Emotional Balance", description: "Regulate emotions calmly.", image: "/courses/course-5.jpg", progress: 20, module_count: 5, lesson_count: 19 },
  { id: 6, title: "Mindfulness Basics", description: "Build awareness & presence.", image: "/courses/course-6.jpg", progress: 0, module_count: 4, lesson_count: 15 },
  { id: 7, title: "Overcoming Overthinking", description: "Break negative thought loops.", image: "/courses/course-7.jpg", progress: 45, module_count: 6, lesson_count: 21 },
  { id: 8, title: "Stress Management", description: "Handle daily stress better.", image: "/courses/course-8.jpg", progress: 0, module_count: 5, lesson_count: 17 },
  { id: 9, title: "Inner Confidence", description: "Build emotional resilience.", image: "/courses/course-9.jpg", progress: 10, module_count: 4, lesson_count: 16 },
  { id: 10, title: "Daily Calm Habits", description: "Create calming routines.", image: "/courses/course-10.jpg", progress: 0, module_count: 5, lesson_count: 18 },
];

export default function Courses() {
  const navigate = useNavigate();
  const courses = useCourseStore((state) => state.courses);
  const setCourses = useCourseStore((state) => state.setCourses);

  const isPremium = localStorage.getItem("isPremium") === "true";

  useEffect(() => {
    setCourses(MOCK_COURSES);
  }, [setCourses]);

  return (
    <div className="page-scroll p-6 safe-top">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">

        <div>
          <h1 className="text-2xl font-bold text-[#1A3C2F]">Courses</h1>
          <p className="text-[#4A6B5D] mt-1">Guided programs for calm & balance</p>
        </div>

        <div className="space-y-4">
          {courses.map((course, index) => {
            const locked = course.id % 2 === 0 && !isPremium;

            return (
              <motion.button
                key={course.id}
                onClick={() => !locked && navigate(`/courses/${course.id}`)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className={`relative w-full text-left overflow-hidden rounded-3xl ${locked ? "opacity-60 cursor-not-allowed" : ""}`}
                style={{ height: "220px" }}
              >
                <img
                  src={course.image}
                  alt={course.title}
                  className="absolute inset-0 w-full h-full object-cover"
                  onError={(e) => (e.currentTarget.src = "/courses/course-1.jpg")}
                />

                <div className="absolute inset-0 bg-black/40" />

                {locked && (
                  <div className="absolute top-4 right-4 bg-black/70 text-white text-xs px-2 py-1 rounded flex items-center gap-1">
                    <Lock className="w-3 h-3" /> Premium
                  </div>
                )}

                <div className="relative z-10 h-full flex flex-col justify-end p-4">
                  <h3 className="text-white text-lg font-bold">{course.title}</h3>
                  <p className="text-white/80 text-sm">{course.description}</p>

                  <div className="flex items-center justify-between mt-2">
                    <span className="text-white/70 text-xs">
                      {course.module_count} modules • {course.lesson_count} lessons
                    </span>
                    {!locked && <ChevronRight className="w-5 h-5 text-white/70" />}
                  </div>
                </div>
              </motion.button>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
}
